module.exports = "<nav class=\"navbar {{navbarType}} {{navbarVariant}} {{navbarfixed}} {{full ? 'navbar-full' : ''}}\">\n\t<slot></slot>\n</nav>";


//////////////////
// WEBPACK FOOTER
// ./src/components/navbar/navbar.html
// module id = 62
// module chunks = 0